import { PagingInfo } from '../../../common/framework/model/PagingInfo';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { apiGet, apiPost } from '../../framework/client';
import { VendorContract } from '../../../common/application/model/VendorContract';
import { buildQuery } from '../../framework/client/resource';

import { VendorContractPublic } from '../../../common/application/model/VendorContractPublic';
import { VendorContractByTypeResult } from '../../../common/application/model/VendorContractByTypeResult';

export async function getVendorContracts(
    parameters: Map<string, string>,
): Promise<Array<VendorContract & { vendorName: string }>> {
    let body: any = {};
    let queryParameters = '';

    const pagingParameters = new Map<string, string>();
    let queryString = ``;

    if (parameters) {
        const query = buildQuery(parameters, queryString, body, pagingParameters, '');
        queryParameters = query.queryParameters;
        body = query.body;
    }

    const response = await apiPost(`/api/resource/vendor-contracts${queryParameters}`, body);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getVendorContractsByType(parameters: Map<string, string>): Promise<VendorContractByTypeResult[]> {
    let body: any = {};
    let queryParameters = '';

    const pagingParameters = new Map<string, string>();
    let queryString = ``;

    if (parameters) {
        const query = buildQuery(parameters, queryString, body, pagingParameters, '');
        queryParameters = query.queryParameters;
        body = query.body;
    }

    const response = await apiPost(`/api/customer-vendor-contracts${queryParameters}`, body);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getVendorContractsByTypePaging(
    customerId: string,
    parameters: Map<string, string>,
): Promise<PagingInfo> {
    let body: any = {};
    let queryParameters = '';

    const pagingParameters = new Map<string, string>();
    let queryString = ``;

    if (parameters) {
        const query = buildQuery(parameters, queryString, body, pagingParameters, '');
        queryParameters = query.queryParameters;
        body = query.body;
    }

    const response = await apiPost(`/api/customer-vendor-contracts/paging${queryParameters}`, body);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getUserServices(vehicleRegistrationNumber: string): Promise<VendorContractPublic[]> {
    const response = await apiGet(`/api/public/customer-services/${vehicleRegistrationNumber}`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getSmartFleetDefaultVendorLocations(
    vehicleRegistrationNumber: string,
): Promise<VendorContractPublic[]> {
    const response = await apiGet(`/api/public/smart-fleet-default-vendor-locations/${vehicleRegistrationNumber}`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getCustomerCarPolicy(
    vehicleRegistrationNumber: string,
): Promise<{ policy: string; customerName: string }> {
    const response = await apiGet(`/api/public/customer-car-policy/${vehicleRegistrationNumber}`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
